export const currentURlName = (value:string) => {
    const result = value.split('/')
    return result[result.length - 1]
}